import reference from "../data/discount-fee-reference.json";
import type { EquipmentItem } from "./equipment-catalog";

// Display-only reference from DiscountsAndFees plus explicitly named fees,
// discounts and credits in Services/Materials. Existing placements stay intact.
export const discountFeeReferenceCount = reference.length;
const normalize = (value: string) => value.trim().replace(/\s+/g, " ").toLowerCase();
const byId = new Map(reference.map((row) => [`st-price_book_item-${row.sourceId}`, row]));
export function consolidatedDiscountFeeCategoryIds(categories: Array<{ id: string; name: string; parentCategoryId: string | null }>) {
  const ids = new Set(categories.filter((category) => /^(discounts|convenience fee)[.!]?$/i.test(normalize(category.name))).map((category) => category.id));
  let previousSize = -1;
  while (previousSize !== ids.size) {
    previousSize = ids.size;
    for (const category of categories) if (category.parentCategoryId && ids.has(category.parentCategoryId)) ids.add(category.id);
  }
  return ids;
}
export function matchesDiscountFeeReference(item: EquipmentItem) {
  const source = byId.get(item.id);
  return Boolean(source && item.sku === source.sourceId && source.names.some((name) => normalize(name) === normalize(item.name)));
}
export function discountFeeItems<T extends EquipmentItem & { modifierType?: "discount" | "fee" | null }>(items: T[], categories: Array<{ id: string; name: string; kind: string; parentCategoryId: string | null }>) {
  const categoryIds = new Set([...consolidatedDiscountFeeCategoryIds(categories), ...categories.filter((category) =>
    category.kind === "discount" || category.kind === "fee" || /^(discounts?|fees?|discounts?\s*(?:&|and)\s*fees?)$/i.test(category.name.trim()),
  ).map((category) => category.id)]);
  let previousSize = -1;
  while (previousSize !== categoryIds.size) {
    previousSize = categoryIds.size;
    for (const category of categories) if (category.parentCategoryId && categoryIds.has(category.parentCategoryId)) categoryIds.add(category.id);
  }
  return items.filter((item) => {
    return item.modifierType === "discount" || item.modifierType === "fee" ||
      matchesDiscountFeeReference(item) ||
      (item.categoryIds || [item.categoryId]).some((id) => categoryIds.has(id));
  }).sort((a, b) => a.name.localeCompare(b.name, "en", { numeric: true, sensitivity: "base" }));
}
